
export default {
    name: 'HeroSection',
}
